import { TextInputFloating } from '@zoom/components';
import classnames from 'classnames';
import { endOfWeek, format, startOfWeek } from 'date-fns';
import React from 'react';

// eslint-disable-next-line import-x/no-cycle
import { InputWrapperProps } from './DatePickerTextFieldInput';
import { useAuth } from '../../app/AuthorizationProvider';

const allowedKeys = ['Escape', 'Tab', 'ArrowDown', 'ArrowUp', 'Enter'];

export const WeekPickerTextFieldInput: React.FC<InputWrapperProps> = ({
  className,
  customClassName,
  dataTestId,
  dateFormat,
  disabled,
  inputId,
  inputRef,
  label,
  onBlur,
  onClick,
  onKeyDown,
  value,
}) => {
  const { localeObj } = useAuth();

  const valueDate = value ? new Date(value) : new Date();

  const startDate = startOfWeek(valueDate, { locale: localeObj });
  const endDate = endOfWeek(valueDate, { locale: localeObj });

  const formattedValueOutput = `${format(startDate, dateFormat, { locale: localeObj })} - ${format(
    endDate,
    dateFormat,
    { locale: localeObj }
  )}`;

  const onKeyDownHandler = (event: any) => {
    if (onKeyDown && allowedKeys.includes(event.key)) {
      onKeyDown(event);
      return;
    }
    event.preventDefault();
  };

  return (
    <div className={classnames('date-picker-input weekpicker', customClassName)}>
      <TextInputFloating
        autoComplete="off"
        className={className}
        data-test-id={dataTestId}
        disabled={disabled}
        id={inputId}
        inputRef={inputRef}
        label={label}
        name={inputId}
        onBlur={onBlur}
        onFocus={onClick}
        onKeyDown={onKeyDownHandler}
        value={formattedValueOutput}
      />
    </div>
  );
};
